import React from 'react';
import { Modal, Typography, Table } from 'antd';
import { ITimesheetHistory } from 'src/models/Timesheet';
import { getDateandTime } from 'src/utils/helpers';
import { TableLoader } from 'src/views/TimeSheet/components/TableLoader';
import en from 'src/messages/en.json';

interface HistoryModalProps {
  show: boolean;
  onHide: () => void;
  history: ITimesheetHistory[] | null;
  isLoading: boolean;
}

export const HistoryModal: React.FC<HistoryModalProps> = ({
  show,
  onHide,
  history,
  isLoading,
}) => {
  const { Title, Text } = Typography;

  const columns = [
    {
      title: en.Timesheet.Title.event,
      dataIndex: 'event',
      key: 'event',
      width: '13%',
      className: 'align-top-cell',
      render: (text) => <Text strong>{text}</Text>,
    },
    {
      title: en.Timesheet.Title.date,
      dataIndex: 'date',
      key: 'date',
      width: '13%',
      className: 'align-top-cell',
    },
    {
      title: en.Timesheet.Title.time,
      dataIndex: 'time',
      key: 'time',
      width: '10%',
      className: 'align-top-cell',
    },
    {
      title: en.Timesheet.Title.by,
      dataIndex: 'by',
      key: 'by',
      width: '35%',
      className: 'align-top-cell',
    },
    {
      title: en.Timesheet.Title.rejectionReason,
      dataIndex: 'reason',
      key: 'reason',
    },
  ];

  // DataSource transformation
  const dataSource =
    history?.map((item, index) => {
      const { localDate, localTime } = getDateandTime(item?.date);

      return {
        key: item.timeSheetId || index,
        event: item.event,
        date: localDate || '-',
        time: localTime || '-',
        by: item.eventCreatedBy || '-',
        reason: item.reason || '-',
      };
    }) || [];

  // Empty state row (optional fallback)
  const hasHistory = history && history.length > 0;

  return (
    <Modal
      centered
      open={show}
      onCancel={onHide}
      maskClosable={false}
      title={
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            padding: '1rem',
          }}
        >
          <Title level={4} style={{ margin: 0 }}>
            {en.Timesheet.Title.historyLogs}
          </Title>
        </div>
      }
      footer={null}
      width={1000}
    >
      <div
        style={{
          maxHeight: '25rem',
          padding: '0 1rem 1rem',
        }}
      >
        {history ? (
          <Table
            columns={columns}
            dataSource={hasHistory ? dataSource : []}
            pagination={false}
            loading={isLoading}
            bordered={false}
            sticky
            scroll={{ y: '21rem' }}
            size="middle"
          />
        ) : (
          <TableLoader />
        )}
      </div>
    </Modal>
  );
};
